import axios from 'axios';
import api from './api';
import { CreateReciboDto, Recibo, ReciboCreateResponse } from '../shared/dtos/Recibo.dto';



export class ReciboService {

  public static async create(createReciboDto: CreateReciboDto): Promise<ReciboCreateResponse[]> {
    try {
      const response = await api.post(`recibo/create`, createReciboDto,
        {
          timeout: 0,
        });
      // Retorna a resposta completa com os números sequenciais específicos de cada recibo
      return response.data;
    } catch (error) {
      console.error('Erro ao criar recibo:', error);
      throw error;
    }
  }

  /**
   * Extrai os números sequenciais específicos de cada recibo a partir da resposta da API
   * @param response Resposta da API de criação de recibo
   * @returns Array de números sequenciais específicos
   */
  public static extrairNumerosSequenciais(response: ReciboCreateResponse[]): string[] {
    const numerosSequenciais: string[] = [];

    // Adiciona números sequenciais de recibos existentes
    if (response && response.length > 0) {
      response.forEach(recibo => {
        if (recibo.numeroSequencial) {
          numerosSequenciais.push(recibo.numeroSequencial);
        }
      });
    }

    // Adiciona números sequenciais de recibos gerados
    if (response && response.length > 0) {
      response.forEach(recibo => {
        if (recibo.numeroSequencial) {
          numerosSequenciais.push(recibo.numeroSequencial);
        }
      });
    }

    return numerosSequenciais;
  }

  public static async findAll(): Promise<Recibo[]> {
    try {
      const response = await api.get(`/find-all`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar recibos:', error);
      throw error;
    }
  }

  /**
   * Busca um recibo pelo ID
   * @param id ID do recibo
   * @returns Recibo encontrado
   */
  public static async findOne(id: number): Promise<Recibo> {
    try {
      const response = await api.get(`/get-by-id/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Erro ao buscar recibo com ID ${id}:`, error);
      throw error;
    }
  }

  /**
   * Busca um recibo pelo número sequencial
   * @param numeroSequencial Número sequencial do recibo
   * @returns Recibo encontrado
   */
  public static async findByNumeroSequencial(numeroSequencial: string): Promise<Recibo> {
    try {
      const response = await api.get(`/get-by-numero-sequencial/${numeroSequencial}`);
      return response.data;
    } catch (error) {
      console.error(`Erro ao buscar recibo com número sequencial ${numeroSequencial}:`, error);
      throw error;
    }
  }
}